import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
  selector: 'app-pagination-buttons',
  templateUrl: './pagination-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaginationButtonsComponent {
  /**
   * Zero-based page index
   */
  @Input({ required: true })
  currentPageIndex: number;

  @Input({ required: true })
  totalPages: number;

  @Input()
  visibleButtonsCount = 3;

  @Output()
  selectPage = new EventEmitter<number>();

  protected getPages(): number[] {
    let startPage = Math.max(0, this.currentPageIndex - Math.floor(this.visibleButtonsCount / 2));
    let endPage = Math.min(this.totalPages - 1, this.currentPageIndex + Math.floor(this.visibleButtonsCount / 2));

    if (endPage - startPage + 1 < this.visibleButtonsCount) {
      if (startPage === 0) {
        endPage = Math.min(this.totalPages - 1, startPage + this.visibleButtonsCount - 1);
      } else {
        startPage = Math.max(0, endPage - this.visibleButtonsCount + 1);
      }
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }
}
